export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: '1',
    name: '影视圈',
    slug: 'film-tv',
    description: '电影电视剧最新八卦爆料，明星片场趣事、新剧路透、票房黑马一网打尽',
    icon: 'ri-movie-2-line',
    articleCount: 128,
  },
  {
    id: '2',
    name: '音乐圈',
    slug: 'music',
    description: '歌手动态、新歌发布、演唱会爆料、音乐榜单背后的故事',
    icon: 'ri-music-2-line',
    articleCount: 96,
  },
  {
    id: '3',
    name: '网红圈',
    slug: 'influencer',
    description: '网红达人最新动态、直播爆料、短视频热点事件追踪',
    icon: 'ri-live-line',
    articleCount: 87,
  },
  {
    id: '4',
    name: '综艺',
    slug: 'variety',
    description: '综艺节目录制花絮、嘉宾爆料、节目争议话题全解析',
    icon: 'ri-tv-2-line',
    articleCount: 74,
  },
  {
    id: '5',
    name: '时尚',
    slug: 'fashion',
    description: '明星穿搭点评、红毯造型分析、时尚品牌合作最新消息',
    icon: 'ri-shirt-line',
    articleCount: 63,
  },
  {
    id: '6',
    name: '体育',
    slug: 'sports',
    description: '体育明星私生活、赛场内外趣闻、运动员跨界娱乐圈动态',
    icon: 'ri-basketball-line',
    articleCount: 55,
  },
  {
    id: '7',
    name: '国际',
    slug: 'international',
    description: '海外娱乐圈动态、好莱坞明星八卦、日韩偶像最新资讯',
    icon: 'ri-global-line',
    articleCount: 91,
  },
  {
    id: '8',
    name: '独家',
    slug: 'exclusive',
    description: '17吃瓜网独家爆料，一手消息来源，深度揭秘娱乐圈内幕',
    icon: 'ri-spy-line',
    articleCount: 42,
  },
];